export const COMMISSION_TIERS_USER = [
  {
    minAmount: 0,
    maxAmount: 10000,
    commissionPercent: 10
  },
  {
    minAmount: 10001,
    maxAmount: 20000,
    commissionPercent: 20
  },
  {
    minAmount: 20001,
    maxAmount: 30000,
    commissionPercent: 25
  },
  {
    minAmount: 30001,
    maxAmount: null,
    commissionPercent: 30
  }
]

export default { COMMISSION_TIERS_USER }
